module.exports = __webpack_public_path__ + "img/btn_order_part_open02.9993855a.svg";